export enum DisputeStateEnum {
  Resolved,
  Unresolved
}

